import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';

import DashboardIcon from '@mui/icons-material/Dashboard';
import MenuItem from '@mui/material/MenuItem';

import { ArchivedDashboardT } from 'business/definitions';
import IconMenu from 'components/IconMenu';
import { capitalize } from 'helpers/helpers';
import UnclickableCard from 'ui/Card/UnclickableCard';
import { useUnarchiveDashboard } from '../../hooks/updateDashboard';
import { ListItemIcon } from '@mui/material';
import RestoreFromTrashIcon from '@mui/icons-material/RestoreFromTrash';
import DashboardPanelDetails from 'components/DashboardPanelDetails/DashboardPanelDetails';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import { formatDate } from 'helpers/formatHelper';

type Props = {
    dashboard: ArchivedDashboardT;
};

const ArchivedDashboardCard = ({ dashboard }: Props): JSX.Element => {
    const { t } = useTranslation();
    const [openPanelDetails, setOpenPanelDetails] = useState<boolean>(false);

    const unarchiveDashboardMutation = useUnarchiveDashboard();
    const lastModifiedText = dashboard.userHistory?.lastEvent
        ? t('dashboard.lastModified', {
              date: formatDate(new Date(dashboard.userHistory.lastEvent.date)),
          })
        : t('dashboard.neverModified');
    return (
        <>
            <UnclickableCard
                size="md"
                title={dashboard.title}
                icon={<DashboardIcon />}
                action={
                    <IconMenu small>
                        <MenuItem
                            onClick={() => {
                                setOpenPanelDetails(true);
                            }}
                        >
                            <ListItemIcon>
                                <InfoOutlinedIcon />
                            </ListItemIcon>
                            {capitalize(t('dashboardEdit.informations'))}
                        </MenuItem>
                        <MenuItem
                            onClick={() => {
                                unarchiveDashboardMutation.mutate({
                                    key: dashboard.key,
                                });
                            }}
                        >
                            <ListItemIcon>
                                <RestoreFromTrashIcon />
                            </ListItemIcon>
                            {capitalize(t('dashboards.unArchive'))}
                        </MenuItem>
                    </IconMenu>
                }
                subtitle={lastModifiedText}
            />
            {openPanelDetails && (
                <DashboardPanelDetails
                    dashboard={dashboard}
                    open={openPanelDetails}
                    onClose={() => setOpenPanelDetails(false)}
                />
            )}
        </>
    );
};

export default ArchivedDashboardCard;
